import React, { useEffect, memo } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Slider from "react-slick"; // Assuming you're using a slider like react-slick
import './Gallery.scss';
import SectionTitle from "../../SectionTitle/SectionTitle";
import { fetchGalleryImages } from "../../../redux/slices/gallerySlice";
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../UI/Loading/Loading';
const Gallery = ({ t }) => {
    const dispatch = useDispatch();
    // Get gallery images and loading status from the Redux store
    const { images, status, error } = useSelector((state) => state.gallery);
    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchGalleryImages()); // Dispatch the action to fetch images
        }
    }, [dispatch, status]);


    if (status === 'loading') {
        return <Loading />;
    }
    // if (status === 'failed') {
    //     return <Typography>Error: {error}</Typography>;
    // }
    const renderGallery = () => (
        <Grid container spacing={4} justifyContent="center" sx={{ width: "100%", ml: "0px !important", }}>
            {images.map((image, index) => (
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    key={index}
                    sx={{
                        ml: "0px !important", // Ensure no left margin override
                        pl: "0px !important", // Ensure no left padding override
                        mb: 4, // Add bottom margin to create space between rows
                        display: "flex", // Ensure the image container takes full available space
                        justifyContent: "center", // Center the image within the grid item
                        padding: "8px", // Add padding around the images to ensure gap
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            width: "100%",
                            paddingBottom: "75%", // Maintain aspect ratio
                            overflow: "hidden",
                            borderRadius: "10px",
                        }}
                    >
                        <Box
                            component="img"
                            src={image.src}
                            loading="lazy"
                            alt={image.alt}
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                // objectFit: "cover",
                                boxShadow: "none",
                                borderRadius: "10px",
                            }}
                        />
                    </Box>
                </Grid>
            ))}
        </Grid>
    );


    const renderSlider = () => (
        <Box data-aos="zoom-in" >
            <Slider
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={3}
                slidesToScroll={1}
                autoplay={true} // Enable autoplay
                autoplaySpeed={3000} // Set autoplay speed (in milliseconds)
                responsive={[
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ]}
                className="slick-slider"

            >
                {images.map((image, index) => (
                    <Box
                        key={index}
                        sx={{
                            position: "relative",
                            paddingBottom: "75%", // Aspect ratio: 4:3
                            overflow: "hidden",
                            borderRadius: "10px",
                            boxShadow: "none",
                        }}
                    >
                        <Box
                            component="img"
                            src={image.src}
                            loading="lazy"
                            alt={image.alt}
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                // objectFit: "cover",
                                boxShadow: "none",
                                borderRadius: "10px",
                            }}
                        />
                    </Box>
                ))}
            </Slider>
        </Box>
    );

    return (
        <Box sx={{ textAlign: "center", mt: 8, mb: 8 }}  >
            <SectionTitle
                title={t.gallery}
                fontSize="32px"
                color="#12538B"
                fontWeight={700}
                lineHeight="39.08px"
                mb={2}
                dataAos="fade-down"
            />
            <Typography
                sx={{
                    fontSize: "20px",
                    color: "#7B7973",
                    fontWeight: 400,
                    mb: 4,
                    lineHeight: "30px",
                }}
            >
                {t.description}
            </Typography>
            {images.length <= 3 ? renderGallery() : renderSlider()}
        </Box>
    );
};

export default Gallery;
